import React from "react";
import { useQuery } from "@apollo/client";
import { GET_CHATS } from "../../graphql/queries";
import {
  Card,
  Button,
  Container,
  Row,
  Col,
  Spinner,
  Alert,
} from "react-bootstrap";

const Chats = () => {
  const { loading, error, data } = useQuery(GET_CHATS);

  if (loading) {
    return (
      <Container className="mt-4 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  if (error) {
    // Handle different error types
    if (error.message.includes("Authentication required")) {
      return (
        <Container className="mt-4">
          <Alert variant="warning">
            <Alert.Heading>Authentication Required</Alert.Heading>
            <p>Please log in to view the chat list.</p>
          </Alert>
        </Container>
      );
    }

    return (
      <Container className="mt-4">
        <Alert variant="danger">
          <Alert.Heading>Error</Alert.Heading>
          <p>{error.message}</p>
        </Alert>
      </Container>
    );
  }

  const chats = data?.chats || [];

  return (
    <Container className="mt-4">
      <h2 className="mb-4">GroupMe Chats</h2>

      {chats.length === 0 ? (
        <Alert variant="info">No chats available.</Alert>
      ) : (
        <Row xs={1} md={2} lg={3} className="g-4">
          {chats.map((chat) => (
            <Col key={chat.id}>
              <Card className="h-100">
                {chat.imageUrl && (
                  <Card.Img
                    variant="top"
                    src={chat.imageUrl}
                    alt={chat.name}
                    style={{ height: "180px", objectFit: "cover" }}
                  />
                )}
                <Card.Body>
                  <Card.Title>{chat.name}</Card.Title>
                  {chat.description && (
                    <Card.Text>{chat.description}</Card.Text>
                  )}
                  <Card.Text>
                    <small className="text-muted">
                      {chat.memberCount} members | {chat.messageCount} messages
                    </small>
                  </Card.Text>
                  <Button variant="primary" href={`/chats/${chat.id}`}>
                    View Chat
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}
    </Container>
  );
};

export default Chats;
